
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Livello_1","data-name":"Livello 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"-150 -150 1000.7 1016"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M700.7 367.7A412.16 412.16 0 00695 300H358v134.5h193c-8.7 44.1-34 81.4-71.6 106.8v.07c-32.18 21.46-73 34.53-121.3 34.53-93.4 0-172.4-62.9-200.8-148h-.1a206.47 206.47 0 01-11.3-68.3 217.33 217.33 0 0111.3-68.3c28.3-85 107.4-148 200.8-148 52.8 0 99.9 18.2 137.2 53.7l102-102C535.5 37.1 454.6 1.6 358 1.6 218.1 1.6 97.2 82.2 38.5 199.1a353.8 353.8 0 000 321C97.2 637 218.1 717.6 358 717.6c96.7 0 177.5-32.2 236.6-86.8h-.05c67.37-62.44 106.15-154.32 106.15-263.1z","transform":"translate(0 -1.6)","fill":"#fff"}})])
          )
        }
      }
    